<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix m-b-5">
      <h3 class="pull-left m-v-0">
        <span v-if="school&&school.name">{{school.name}} -</span>
        <span v-if="is_edit">编辑班级</span>
        <span v-else>创建班级</span>
      </h3>
    </div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入班级名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="任教教师">
            <el-select v-model="form.teachers" multiple placeholder="请选择任教教师" class="full-width"
                       filterable :filter-method="filterTeacher">
              <el-option v-for="teacher in filtered_teachers"
                         :label="teacher.name+teacherSubjects(teacher)"
                         :key="teacher.uid" :value="teacher.uid">
                <span v-html="$highlight(teacher.name, teacher.$$pinyin.name)"></span>
                {{teacherSubjects(teacher)}}
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="学段">
            <el-select v-model="form.grade" placeholder="请选择学段" class="full-width">
              <el-option v-for="grade in grades" :key="grade" :label="grade" :value="grade"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入学年份">
            <el-input v-model="form.year" :placeholder="year"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="text-center m-v-10">
        <el-button type="primary" size="cons" @click="submit()" :loading="submit_loading>0">提交</el-button>
        <el-button type="default" size="cons" @click="$router.back()">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import * as Group from 'api/group'
import * as School from 'api/school'
import * as Teacher from 'api/teacher'
import * as Subject from 'api/configuration/subject'

import * as rules from 'common/rules'

export default {
  data () {
    return {
      ready: false,
      form: null,
      submit_loading: 0,
      year: new Date().getFullYear() + '',
      search: '',
      teachers: [],
      rules: {
        name: [rules.required('班级姓名为必填项')],
      },
    }
  },
  computed: {
    is_edit () {
      return !!this.$query.group_uid
    },
    filtered_teachers () {
      return this.$search(this.teachers, this.search, ['name'])
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let query = this.$query
        let [form, school, subjects, teachers] = await Promise.all([
          query.group_uid ? Group.get(query) : null,
          query.school_uid ? School.get(query) : null,
          Subject.list(),
          Teacher.list(query),
        ])
        form = form || {
          name: '',
          grade: '',
          year: this.year,
          teachers: this.$query.user_uid ? [this.$query.user_uid] : [],
        }
        form.school_uid = query.school_uid
        form.group_uid = form.uid = query.group_uid
        this.form = form
        this.school = school
        this.grades = Subject.getGrades(subjects)
        this.teachers = teachers
        this.ready = true
      })
    },
    async submit () {
      if (!await this.$validate(this.$refs.form)) return
      this.$guard(this, 'submit_loading')(async () => {
        await Group.edit(this.form)
        this.$message.success(this.is_edit ? '更新成功' : '创建成功')
        if (!this.is_edit) this.$router.back()
      })
    },
    filterTeacher (search) {
      this.search = search
    },
    teacherSubjects (teacher) {
      if (teacher.subjects && teacher.subjects.length) return `(${teacher.subjects.join('、')})`
      return ''
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/group/GroupEdit.vue